// extracted by mini-css-extract-plugin
export default {"overlayContainer":"OfflineOverlayHOC__overlayContainer___rA8Pc","container":"OfflineOverlayHOC__container___ExL8k","modalContent":"OfflineOverlayHOC__modalContent___fmmVG"};